import styled, { css } from "styled-components";
import { loadingSkeleton } from "../../../styles/animations/loading-skeleton";

export const addReqsButtonStyles = css`
  width: fit-content;
  height: auto;
  min-height: 30px;
  font-size: 1rem;
`;

export const deleteButtonStyles = css`
  width: fit-content;
  font-size: 1rem;
`;

export const CloseBtn = styled.button`
  display: grid;
  place-content: center;
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  cursor: pointer;

  border: none;
  border-radius: 4px;
  background-color: var(--primary-dark-50);
  transition: background-color 0.3s;

  > svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: var(--primary-blue);
    stroke-width: 2.8;
  }

  &:hover {
    background-color: var(--primary-dark-100);
  }
`;

export const iconTextButtonStyles = css`
  flex-direction: row-reverse;
  gap: 5px;
  color: var(--primary-dark-300);
  font-family: Rubik;
  font-size: 0.857rem; // 12px
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
  padding: 10px 0px;

  > svg {
    color: var(--primary-blue);
  }

  &:hover {
    color: var(--primary-blue);
  }

  && {
    width: fit-content;
  }
`;

export const SkeletonSection = styled.div`
  width: 350px;
  height: 536px;
  border: 1px solid var(--primary-grey-200);
  border-radius: 8px;
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProfileBackground = styled.div`
  background-color: var(--primary-dark-50);
  min-height: 100vh;
  width: 100%;
`;

export const ProfileNavigation = styled.div`
  min-height: 50px;
  flex-shrink: 0;
  background-color: var(--primary-white);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px 10px 30px;
`;

export const NavTitle = styled.h1`
  color: var(--primary-blue-300);
  font-family: Rubik;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 68px;
  margin: 0 auto;
  padding: 40px 40px 40px;
  transition: gap 0.2s;
  max-width: 1600px;
  transition: max-width 0.2s ease;

  position: relative;

  @media screen and (max-width: 1400px) {
    gap: 25px;
  }

  @media screen and (max-width: 960px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const SidebarIcon = styled.div`
  display: none;
  @media screen and (max-width: 1240px) {
    display: block;
  }
`;

export const LayoutIcon = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: -25px;

  @media screen and (max-width: 1240px) {
    display: block;
  }
`;

export const ProfilesSidebar = styled.div`
  position: sticky;
  top: 90px;
  display: flex;
  width: 325px;
  min-height: 745px;
  padding: 30px 15px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex-shrink: 0;
  background-color: var(--primary-dark-50);
  transition: left 0.3s ease, width 0.3s ease;

  @media screen and (max-width: 1240px) {
    position: absolute;
    top: 0;
    left: ${({ $isOpen }) => ($isOpen ? "0" : "-250px")};
    width: ${({ $isOpen }) => ($isOpen ? "250px" : "0")};
    height: 100%;
    z-index: 10;
    border-top: 1px solid var(--primary-dark-200);
    border-right: 1px solid var(--primary-dark-200);
    border-bottom: 1px solid var(--primary-dark-200);
    border-left: none;
    border-top-left-radius: 0;
    border-top-right-radius: 7px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 7px;
    overflow: hidden;
    margin-top: 20px;
  }
`;

export const SidebarBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-items: stretch;
  width: 100%;
`;

export const ConfigureButton = styled.span`
  color: var(--primary-dark-600);
  font-family: Rubik;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: flex;
  padding: 2px 7px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background-color: var(--primary-yellow);
`;

export const CategoryItem = styled.div`
  color: var(--primary-blue);
  font-family: Rubik;
  font-size: 1rem;
  line-height: 17px;
  font-style: normal;
  font-weight: 400;
  border: 1px solid var(--primary-dark-200);
  border-radius: 3px;
  padding: 6px 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  overflow-wrap: break-word;
  min-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  &:hover {
    background-color: var(--primary-blue-200);
    color: var(--primary-blue);

    ${ConfigureButton} {
      background-color: var(--primary-yellow-300, #f0c43f);
    }
  }

  ${({ $needsConfig }) =>
    $needsConfig &&
    css`
      color: var(--primary-dark-50);
      font-weight: 500;
      background-color: var(--primary-dark-600);

      &:hover {
        background-color: var(--primary-dark-600);
        color: var(--primary-dark-50);
      }
    `}
`;

export const ProfileContent = styled.div`
  flex: 1;
  font-family: Rubik, sans-serif;
  min-width: 530px;
  position: relative;
`;

export const PageHeader = styled.h2`
  color: var(--primary-dark-300);
  font-family: Rubik;
  font-size: 0.786rem; // 11px
  line-height: normal;
  font-style: normal;
  font-weight: 500;
  margin: 0;

  display: flex;
  padding-top: 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-top: 1px solid var(--primary-dark-200);
`;

export const FloatingHeader = styled(PageHeader)`
  border-top: none;
  padding-top: 0;
  font-size: 1rem;
  line-height: normal;
`;

export const SideHeader = styled.h2`
  color: var(--primary-dark-600);
  font-family: Rubik;
  font-size: var(--fs-base);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0 0 20px 0;
`;

export const EmptyStateHeader = styled.h1`
  color: var(--primary-dark);
  line-height: normal;
  font-size: var(--fs-lg);
  font-family: Rubik;
  margin: 0;
`;

export const EmptyStateText = styled.p`
  color: var(--primary-grey);
  line-height: 20px;
  font-size: 1rem;
  font-family: Rubik;
  margin-bottom: ${({ mb }) => mb};
`;

export const BottomButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  padding-top: 24px;

  @media screen and (max-width: 960px) {
    padding-top: 0;
    margin-top: 0;
  }
`;

export const NotPermittedBox = styled.div`
  display: grid;
  place-content: center;
  gap: 10px;

  margin: 4rem auto 2rem;
  padding: 2rem;
  height: 400px;
  max-width: 600px;

  text-align: center;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const Skeleton = styled.div`
  ${loadingSkeleton()};
  width: 100%;

  height: ${({ height }) => height || "21px"};
  margin: ${({ margin }) => margin};
`;
